// App utils
import { datajsArray, datajsFirst, trapFocus } from '../shared/utils';

(function() {
	const showMenuElement = datajsFirst('show-off-canvas-section');
	const hideMenuElements = datajsArray('hide-off-canvas-section');

	const showOffCanvasSection = e => {
		trapFocus(document.getElementById('off-canvas-section'));
		showMenuElement.setAttribute('aria-expanded', 'true');
		hideMenuElements.forEach(item => {
			item.setAttribute('aria-expanded', 'true');
		});

		// Transition CSS class 1
		document.body.classList.add('has-activated-menu');

		// Transition CSS class 2
		setTimeout(function() {
			document.body.classList.add('has-menu');
		}, 10);

		return false;
	};

	const hideOffCanvasSection = e => {
		showMenuElement.setAttribute('aria-expanded', 'false');
		hideMenuElements.forEach(item => {
			item.setAttribute('aria-expanded', 'false');
		});

		// Remove Transition CSS class 2
		document.body.classList.remove('has-menu');

		// Remove Transition CSS class 1
		setTimeout(function() {
			document.body.classList.remove('has-activated-menu');
		}, 500);
		return false;
	};

	const handleDocumentKeyUp = e => {
		// Close menu using Esc key.
		if (e.keyCode === 27) {
			hideOffCanvasSection();
		}
	};

	const offCanvasNav = () => {
		showMenuElement.addEventListener('click', showOffCanvasSection);
		hideMenuElements.forEach(item => item.addEventListener('click', hideOffCanvasSection));

		// Handle document keyup event
		document.addEventListener('keyup', handleDocumentKeyUp);
	};

	document.addEventListener('DOMContentLoaded', offCanvasNav);
})();
